import { DefaultTabBar } from 'rmc-tabs';
import { ingredientTabId } from "constants/ingredientsSearch";

const margin = 20;
export default class TabBar extends DefaultTabBar {
    constructor(props) {
        super(props);
        this.tabObject = {
            domTabWidth: 0,
            totalTabBarWidth: 0,
            prevTransformedPosition: 0,
            tabWidths: []
        };
        this.state = {
            showPrev: false,
            showNext: false
        }
    }

    componentDidMount() {
        this.tabObject.domTabWidth = document.getElementById(ingredientTabId).clientWidth;
        this.tabObject.totalTabBarWidth = this.props.tabs.reduce((accumulator, tab) => accumulator + margin + parseInt(document.getElementById(tab.key).clientWidth), 0);
        // listens to dimention changes
        window.addEventListener('resize', this.updateDimensions);
        this.setState({ showNext: this.tabObject.domTabWidth < this.tabObject.totalTabBarWidth })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    componentDidUpdate() {
        const { tabs } = this.props;
        this.tabObject.domTabWidth = document.getElementById(ingredientTabId).clientWidth;
        tabs.forEach((tab, index) => {
            this.tabObject.tabWidths.splice(index, 1, {
                index: index,
                width: parseInt(document.getElementById(tab.key).clientWidth)
            })
        })
        this.tabObject.totalTabBarWidth = this.tabObject.tabWidths.reduce((accumulator, tab) => {
            tab.startPosition = accumulator;
            return accumulator + tab.width + margin;
        }, 0);
    }

    updateDimensions = () => {
        // re-renders and updates the componenet
        const { domTabWidth, totalTabBarWidth } = this.tabObject;
        this.setState({
            width: window.innerWidth,
            showNext: domTabWidth < totalTabBarWidth
        });
    }

    getTransformByIndex = props => {
        const {
            tabWidths,
            totalTabBarWidth,
            domTabWidth,
            prevTransformedPosition
        } = this.tabObject;
        if (domTabWidth + margin > totalTabBarWidth) {
            return {
                transform: this.getPxStyle(0),
                showPrev: false,
                showNext: false
            };
        }

        const activeTab = props.activeTab,
            centerPosition = domTabWidth / 2,
            activeTabProps = tabWidths[activeTab],
            startPosition = activeTabProps.startPosition + prevTransformedPosition,
            endPosition = startPosition + activeTabProps.width,
            nextBuffer = tabWidths[Math.min(tabWidths.length - 1, activeTab + 1)].width / 2,
            prevBuffer = tabWidths[Math.max(0, activeTab - 1)].width / 2,
            lastTabWidths = tabWidths[tabWidths.length - 1],
            firstTabWidths = tabWidths[0];
        let nextTransformPosition = prevTransformedPosition;

        // if active tab is the last tab
        if (activeTab === tabWidths.length - 1 && endPosition > domTabWidth) {
            nextTransformPosition = domTabWidth - lastTabWidths.width - lastTabWidths.startPosition - margin;
            // if active tab is next to center and closer to the edge
        } else if (activeTab !== tabWidths.length - 1 && centerPosition <= startPosition &&
            endPosition <= domTabWidth && (domTabWidth - endPosition) <= nextBuffer) {
            nextTransformPosition = prevTransformedPosition + domTabWidth - endPosition - nextBuffer;
            // if active tab is half visible on the edge
        } else if (endPosition > domTabWidth) {
            nextTransformPosition = prevTransformedPosition + domTabWidth - endPosition - nextBuffer;
            // if active tab is the first tab and half visible on the root
        } else if (activeTab === 0 && startPosition < 0) {
            nextTransformPosition = 0;
            // if active tab is before the center and closer to the root
        } else if (activeTab !== 0 && endPosition <= centerPosition && startPosition > 0 && startPosition < prevBuffer) {
            nextTransformPosition = prevTransformedPosition + prevBuffer - startPosition;
            // if active tab is half visible on the root
        } else if (startPosition < 0) {
            nextTransformPosition = prevTransformedPosition - startPosition + prevBuffer;
        }

        return {
            transform: this.getPxStyle(nextTransformPosition),
            showPrev: firstTabWidths.startPosition + nextTransformPosition < 0,
            showNext: lastTabWidths.startPosition + lastTabWidths.width + nextTransformPosition > domTabWidth
        };
    };

    getPxStyle(value) {
        this.tabObject.prevTransformedPosition = value;
        return `translate3d(${value}px, 0px, 0px)`;
    }
}
